enum BRAND_THEME {
  BRAND = 'brand-theme',
}
enum IconButtonSize {
  DEFAULT = 'default',
  LARGE = 'large',
}
export { BRAND_THEME, IconButtonSize };
